export default __webpack_public_path__ + "static/logoCombiphar-447b8dbe17658100069b9a90874322e8.svg";